export default __webpack_public_path__ + "static/media/appDrawer.cce03223.png";